import "@/lib/_jquery";

document.addEventListener("turbo:load", () => {
  $(".card-detect-form-change form").each(function() {
    if (this.dataset.cardDetectChangeInitialized) return;
    this.dataset.cardDetectChangeInitialized = "true";
    const $form = $(this);
    const $card = $form.closest(".card");
    const $header = $card.find(".card-header");
    const original_form = $form.serialize();
    $form.find(".form-control").on("change input trix-change", function() { // trix-editor is not found by :input, and it fires a trix-change event when the content changes. Assuming all forms use bootstrap, .form-control can be used instead of :input
      const changed = $form.serialize() !== original_form;
      $card.toggleClass("border-primary", changed);
      $header.toggleClass('bg-primary text-white', changed);
      $card.find('.unsaved-changes').toggleClass('invisible', ! changed);
    });
  });
});

// Input changes detect function
// Detects changes in form inputs with the class 'form-control' and a parent with the class 'detect-form-change'
document.addEventListener("turbo:load", () => {
  $(".detect-form-change form").each(function() {
    if (this.dataset.detectChangeInitialized) return;
    this.dataset.detectChangeInitialized = "true";
    const form = $(this);
    const inputs = form.find(":input, trix-editor"); // again assuming only bootstrap forms used
    let changed = false;
    inputs.each(function() {
      const i = $(this);
      if (i.prop("type") == "checkbox") {
        // Save current value of element
        i.data("oldVal", i.prop("checked"));

        // Look for changes in the value by several methods
        i.on("propertychange click change", function () {
          changed = i.prop("checked") != !!i.data("oldVal");
          i.parent().toggleClass("input-changed", changed);
        });
      } else if (i.prop("type") == "radio") {
        let originalRadio: JQuery<HTMLElement>;
        const siblingRadios = i.parent().siblings(".form-check").children(":input");
        if (i.prop("checked")) {
          originalRadio = i;
        } else {
          siblingRadios.each(function () {
            if ($(this).prop("checked")) {
              originalRadio = $(this);
            }
          });
        }

        // Save current value of element
        i.data("oldVal", i.prop("checked"));

        // Look for changes in the value by several methods
        i.on("propertychange change",function () {
          changed = i.prop("checked") != !!i.data("oldVal");

          // Manually make all sibling radios to look unchanged (cant detect deselects)
          siblingRadios.each(function () {
            $(this).parent().toggleClass("input-changed", false);
          });

          if (originalRadio != null) {
            if (i == originalRadio) {
              i.parent().toggleClass("input-changed", changed);
            } else {
              i.parent().toggleClass("input-changed", changed);
              originalRadio.parent().toggleClass("input-changed", changed);
            }
          } else {
            i.parent().toggleClass("input-changed", changed);
          }
        });

      } else if (i.is("trix-editor")) {
        // the trix editor stores it data as an internal, immutable object. So it should be fine to use it as comparison.
        i.data("oldVal", (i[0] as any).editor.getDocument());
        i.on("trix-change", ()=>{
          if (!i.data("oldVal").isEqualTo((i[0] as any).editor.getDocument()))
            i.toggleClass("input-changed", true);
          else
            i.toggleClass("input-changed", false);
        })
      } else {
        // Save current value of element
        i.data("oldVal", i.val());

        // Look for changes in the value by several methods
        i.on("propertychange input paste", function() {
          changed = i.data("oldVal") != i.val();
          i.toggleClass("input-changed", changed);
        });
      }
    });
  });
});